import {gsap} from "gsap";

const dropdownMenu = {
    tl: null,
    delay: 250,
    progress: 0,
    navbarItems: null,

    init: function () {
        let self = this;
        self.navbarItems = "";

        self.navbarItems = Array.prototype.slice.call(document.querySelectorAll('.c-navbar__nav-item-dropdown'));
        if (!self.navbarItems.length) {
            return
        }


        self._timeline();
        self._dropDownBehaviour(self.navbarItems);
    },

    _dropDownBehaviour(navbarItems) {
        let self = this;

        navbarItems.forEach(function (navbarItem) {
           navbarItem.addEventListener('click', function () {
                let dropDownMenu = navbarItem.parentElement.querySelector('.c-dropdown-menu__content');

                if (document.querySelectorAll('.c-dropdown-menu__content--opened').length >= 1 && dropDownMenu.classList.contains('c-dropdown-menu__content--closed')) {

                    let allOpenedDropdowns = Array.prototype.slice.call(document.querySelectorAll('.c-dropdown-menu__content--opened'));
                    allOpenedDropdowns.forEach(function (item) {
                        if (item !== dropDownMenu) {
                            item.classList.remove('c-dropdown-menu__content--opened');
                            item.classList.add('c-dropdown-menu__content--closed');
                            item.parentElement.classList.remove('c-dropdown-menu__arrow--opened');
                            if (item.parentElement.querySelector('a').getAttribute('aria-expanded') ==='true') {
                                item.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
                            }
                        }
                    });
                }

                if (dropDownMenu.classList.contains('c-dropdown-menu__content--closed')) {
                    dropDownMenu.classList.add('c-dropdown-menu__content--opened');
                    dropDownMenu.querySelector('a').focus();
                    dropDownMenu.parentElement.classList.add('c-dropdown-menu__arrow--opened');

                    if (dropDownMenu.parentElement.querySelector('a').getAttribute('aria-expanded') ==='false') {
                        dropDownMenu.parentElement.querySelector('a').setAttribute('aria-expanded', 'true');
                    }
                    dropDownMenu.classList.remove('c-dropdown-menu__content--closed');
                    self.tl.play();

                }
                else {
                    self.tl.reverse();
                    dropDownMenu.parentElement.classList.remove('c-dropdown-menu__arrow--opened');
                    if (dropDownMenu.parentElement.querySelector('a').getAttribute('aria-expanded') ==='true') {
                        dropDownMenu.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
                    }
                }
            });

        });

    },

    _timeline: function () {

        let reverseComplete = false;
        let self = this;
        let dropDowns = Array.prototype.slice.call(document.querySelectorAll('.c-dropdown-menu__content'));


        self.tl = gsap.timeline({paused: true, reversed: true, onReverseComplete: function () {
                reverseComplete = true;
                let item = document.querySelector('.c-dropdown-menu__content--opened');
                if((reverseComplete) && (item)) {
                    item.classList.remove('c-dropdown-menu__content--opened');
                    item.classList.add('c-dropdown-menu__content--closed');
                    self.progress = 0;
                    self.tl.kill();
                }
            }});


        self.tl.fromTo(dropDowns, 0.3, {top: 0, delay: .1, ease: 'Power2.inOut'}, {top: 70, autoAlpha: 1});
        self.tl.progress(self.progress);
    },

    reInit: function () {
        let self = this;
        self.progress = 0;
        self.tl.kill();
        self.tl.set(document.querySelectorAll('.c-dropdown-menu__content'), {clearProps: 'all'});
        self.tl = "";
        self.init();

    }
};

dropdownMenu.init();


document.addEventListener('LokiRequestEnd', function () {
    dropdownMenu.reInit();
});

